import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { PageHeader } from "./PageHeader";
import { pageLayoutClass } from "./pageLayout";

export interface PageFrameProps {
  title?: string;
  description?: string;
  icon?: LucideIcon;
  actions?: ReactNode;
  breadcrumb?: ReactNode;
  className?: string;
  children?: ReactNode;
}

/**
 * Page layout shell: optional header (breadcrumb, title, actions) and body slot.
 * For loading/error/back navigation with app defaults, use `PageFrame` from `@/components/common`.
 */
export function PageFrame({
  title,
  description,
  icon,
  actions,
  breadcrumb,
  className,
  children,
}: PageFrameProps) {
  const showHeader =
    (title != null && title !== "") ||
    description != null ||
    actions != null ||
    breadcrumb != null;

  return (
    <div className={cn(pageLayoutClass, className)}>
      {showHeader ? (
        <PageHeader
          title={title ?? ""}
          description={description}
          icon={icon}
          actions={actions}
          breadcrumb={breadcrumb}
        />
      ) : null}
      {children}
    </div>
  );
}
